import React, { useEffect, useState, useRef } from "react";
 import './priceList-styles.css';
import ReactDOMServer from 'react-dom/server';

const PricelistRevision = (({ json, revision, removeOld }) => {
    const [displayedHtml, setDisplayedHtml] = useState();
    const containerRef = useRef(null); // Reference for dynamically rendered content
    let mtbAssetHtml = null;

    useEffect(() => {
        createMtbAssetHtml(json);
    }, [json, removeOld]);

    useEffect(() => {
        const container = containerRef.current;

        if (container) {
            const handleSelectChange = (event) => {
                if (event.target.tagName === "SELECT") {
                    const countryToFind = event.target.value.toLowerCase();

                    // Dynamically handle table row filtering
                    const rows = container.querySelectorAll("tr[trtype='country']");
                    rows.forEach((row) => {
                        const rowCountry = row.children[0]?.textContent.toLowerCase();

                        if (countryToFind === "all") {
                            row.style.display = "table-row";
                        } else if (countryToFind === "") {
                            row.style.display = rowCountry !== "country" ? "none" : "table-row";
                        } else {
                            row.style.display =
                                rowCountry === countryToFind || rowCountry === "country"
                                    ? "table-row"
                                    : "none";
                        }
                    });
                }
            };

            // Add event listener for `select` changes
            container.addEventListener("change", handleSelectChange);

            // Clean up event listener
            return () => {
                container.removeEventListener("change", handleSelectChange);
            };
        }
    }, [displayedHtml]);

    const removeOldOnes = (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html.join(""), "text/html");

        // Remove divs with "bold old" or "old"
        const oldDivs = doc.querySelectorAll("div.bold.old, div.old");
        oldDivs.forEach((div) => div.remove());

        // Remove classes "bold new" or "new" but keep the div
        const newDivs = doc.querySelectorAll("div.bold.new, div.new");
        newDivs.forEach((div) => {
            div.classList.remove("bold", "new");
        });

        // Remove all <td> containing <div> with status="deleted"
        const deletedDivs = doc.querySelectorAll("div[status='deleted']");
        deletedDivs.forEach((deletedDiv) => {
            const parentTd = deletedDiv.closest("td");
            if (parentTd) {
                parentTd.remove();
            }
        });

        // Remove all divs that contain a <span> with a <div> with status="deleted"
        const divsWithSpans = doc.querySelectorAll("div");
        divsWithSpans.forEach((div) => {
            const spanWithDeletedDiv = div.querySelector("span div[status='deleted']");
            if (spanWithDeletedDiv) {
                spanWithDeletedDiv.closest("div.mt-20").remove();
            }
        });

        // Remove tables that are empty and their parent div with class "mt-20"
        const tables = doc.querySelectorAll("table");
        tables.forEach((table) => {
            const rows = table.querySelectorAll("tr");
            const allRowsEmpty = Array.from(rows).every((row) => {
                return Array.from(row.childNodes).every((cell) => {
                    return cell.nodeType === Node.TEXT_NODE && cell.textContent.trim().length === 0;
                });
            });

            if (allRowsEmpty) {
                const parentDiv = table.closest("div.mt-20");
                if (parentDiv) {
                    parentDiv.remove();
                }
            }
        });
        // Remove divs where all inner divs are empty
        const allDivs = doc.querySelectorAll("div");
        allDivs.forEach((div) => {
            const childDivs = Array.from(div.children).filter(child => child.tagName === "DIV");
            const allInnerDivsEmpty = childDivs.every((childDiv) => childDiv.textContent.trim().length === 0);
            if (allInnerDivsEmpty && childDivs.length > 0) {
                div.remove();
            }
        });
        // Update displayedHtml with the modified content
        // setDisplayedHtml([doc.body.innerHTML]);
        return [doc.body.innerHTML];
    };

    const createMtbAssetHtml = (json) => {
        if (json) {
            const mtbassetObj = json;
            const { priceListRevisions } = mtbassetObj;
            const revisionsHtml = Object.entries(priceListRevisions)
                .map(([key, value]) => `<revision revNumber='${key}'>${value}</revision>`)
                .join("");

            // const activationDatesHtml = Object.entries(activationDates)
            //     .map(([key, value]) => `<activationDate dateNumber='${key}'>${value}</activationDate>`)
            //     .join("");
            //
            // const prevActivationDatesHtml = Object.entries(prevActivationDates)
            //     .map(([key, value]) => `<previousActivationDate dateNumber='${key}'>${value}</previousActivationDate>`)
            //     .join("");

            mtbAssetHtml = `
      <mtbasset assetid='${mtbassetObj.assetId}' mtbid='${mtbassetObj.mtbId}'>
        <name>${mtbassetObj.assetName}</name>
        <revisions>${revisionsHtml}</revisions>
      </mtbasset>
    `.replace('<?xml version="1.0" encoding="utf-8" standalone="yes"?>', '')
                .replace(/\n/g, '')
                .replace(/\\/g, '');
            // console.log('mtbAssetHtml', mtbAssetHtml)
            // Parse mtbAssetHtml into a DOM object
            const parser = new DOMParser();
            const doc = parser.parseFromString(mtbAssetHtml, "text/html"); // Use "text/html" for HTML parsing

            // // Query all revisions
            // const revisions = doc.querySelectorAll(`mtbasset[mtbid='${mtbassetObj.mtbId}'] revision`);
            // // console.log("Revisions found:", revisions);
            //
            // // Convert NodeList to an array of revision data
            // const revisionData = Array.from(revisions).map((revision) => ({
            //     revNumber: revision.getAttribute("revNumber"),
            //     content: revision.innerHTML.trim(),
            // }));
            //
            // // console.log("Extracted Revisions:", revisionData);
            // const revisionMax = revisions.length;

            const hasPageData = doc.querySelector(
                `mtbasset[mtbid='${mtbassetObj.mtbId}'] revision[revnumber='${revision}'] pagedata`
            );
            if (hasPageData) {
                const templates = hasPageData.querySelector(
                    `template`
                );
                const subTemplates = fetchSubTemplates(mtbassetObj?.mtbId);
                // console.log('subTemplates', subTemplates);
                createContentWithPageData(subTemplates);
                const response = createContentWithPageData(subTemplates);
                // console.log('createContentWithPageData', response)
                // render the response
                let contentWithPageDataArray = response.map((element) =>
                    ReactDOMServer.renderToString(element)
                );
                contentWithPageDataArray = processRenderedHtmlArray(contentWithPageDataArray);

                // console.log('renderedHtmlArray', contentWithPageDataArray[0]);
                if (removeOld) {
                    contentWithPageDataArray = removeOldOnes(contentWithPageDataArray);
                }
                setDisplayedHtml(contentWithPageDataArray);
                return contentWithPageDataArray;
            } else {
                return;
            }
        }

        return;
    };

    function decodeHtmlEntities(html) {
        // Create a temporary DOM element to decode HTML entities
        const textArea = document.createElement('textarea');
        textArea.innerHTML = html;
        return textArea.value;
    }

    function processRenderedHtmlArray(renderedHtmlArray) {
        return renderedHtmlArray.map((html) => {
            // Decode HTML entities like &lt; and &gt; into actual HTML tags
            const decodedHtml = decodeHtmlEntities(html);

            // Parse the decoded HTML into a DOM structure
            const parser = new DOMParser();
            const doc = parser.parseFromString(decodedHtml, 'text/html');

            // Handle `div[status="unchanged"]`
            const unchangedDivs = doc.querySelectorAll('div[status="unchanged"]');
            unchangedDivs.forEach((unchangedDiv) => {
                const oldVersionDiv = unchangedDiv.querySelector('div[version="old"]');
                if (oldVersionDiv) {
                    oldVersionDiv.remove();
                }

                const newVersionDiv = unchangedDiv.querySelector('div[version="new"]');
                if (newVersionDiv) {
                    newVersionDiv.removeAttribute('version');
                }
            });

            // Handle `div[status="deleted"]`
            const deletedDivs = doc.querySelectorAll('div[status="deleted"]');
            deletedDivs.forEach((deletedDiv) => {
                const newVersionDiv = deletedDiv.querySelector('div[version="new"]');
                if (newVersionDiv) {
                    newVersionDiv.remove();
                }
            });

            // Handle `div[status="added"]`
            const addedDivs = doc.querySelectorAll('div[status="added"]');
            addedDivs.forEach((addedDiv) => {
                const oldVersionDiv = addedDiv.querySelector('div[version="old"]');
                if (oldVersionDiv) {
                    oldVersionDiv.remove();
                }
            });

            // Add classes for modified `div[version="old"]`
            const oldVersionDivs = doc.querySelectorAll('div[version="old"]');
            oldVersionDivs.forEach((oldVersionDiv) => {
                oldVersionDiv.classList.add('bold', 'old');
                oldVersionDiv.textContent = oldVersionDiv.textContent; // Reset to plain text
            });

            // Add classes for `div[version="new"]` and add the text content again
            const newVersionDivs = doc.querySelectorAll('div[version="new"]');
            newVersionDivs.forEach((newVersionDiv) => {
                newVersionDiv.classList.add('bold', 'new');
                newVersionDiv.textContent = newVersionDiv.textContent; // Reset to plain text
            });

            // Add classes to `<td>` elements based on the number of children in `<tr>`
            const rows = doc.querySelectorAll('tr');
            rows.forEach((row) => {
                const cells = row.children;
                if (cells.length > 1) {
                    // Add "left" to the first child and "right" to the others
                    Array.from(cells).forEach((cell, index) => {
                        if (index === 0) {
                            cell.classList.add('left');
                        } else {
                            cell.classList.add('right');
                        }
                    });
                } else if (cells.length === 1) {
                    // Add "center" to the only child
                    cells[0].classList.add('center');
                }
            });

            // // Handle `td[valign]` to set `text-align` styles
            // const valignElements = doc.querySelectorAll('td[valign]');
            // valignElements.forEach((element) => {
            //     const valignValue = element.getAttribute('valign');
            //     let textAlign;
            //
            //     if (valignValue === 'middle') {
            //         textAlign = 'center';
            //     } else if (valignValue === 'right') {
            //         textAlign = 'right';
            //     } else if (valignValue === 'left') {
            //         textAlign = 'left';
            //     }
            //
            //     if (textAlign) {
            //         const existingStyle = element.getAttribute('style') || '';
            //         element.setAttribute('style', `${existingStyle} text-align: ${textAlign};`);
            //     }
            // });

            // Serialize the modified HTML back to a string
            const updatedHtml = doc.body.innerHTML;

            // Convert the modified HTML into a React element
            return updatedHtml;
        });
    }

    const fetchSubTemplates = (mtbid) => {
        // Parse mtbAssetHtml into a DOM object
        const parser = new DOMParser();
        const doc = parser.parseFromString(mtbAssetHtml, "text/html"); // HTML parsing

        let subtemplatesToReturn = [];

        // Find the template content for the given mtbid and revision
        const templateElement = doc.querySelector(
            `mtbasset[mtbid='${mtbid}'] revision[revnumber='${revision}'] pagedata template`
        );
        // console.log('templateElement', templateElement);

        if (!templateElement) {
            console.warn("Template not found for the given mtbid and revision.");
            return subtemplatesToReturn;
        }

        // Access the content of the <template> element
        const templateContent = templateElement.content || templateElement;

        // Get the children of the template content
        if (templateContent.children) {
            subtemplatesToReturn = Array.from(templateContent.children);
        } else {
            subtemplatesToReturn = Array.from(templateElement.children);
        }

        // Check if the first child is an <internationals> element
        if (subtemplatesToReturn.length > 0 && subtemplatesToReturn[0].nodeName.toLowerCase() === "internationals") {
            subtemplatesToReturn = Array.from(subtemplatesToReturn[0].querySelectorAll("subtemplate"));
        }

        return subtemplatesToReturn;
    };

    const createContentWithPageData = (subtemplates) => {
        const content = [];
        let numTables = 0;
        let numBullet = 0;

        subtemplates.forEach((currentSub) => {
            // Extract table data
            const tableData = currentSub.querySelectorAll("table tbody");
            if (tableData && tableData.length > 0) {
                Array.from(tableData).forEach((table) => {
                    const header = table.querySelector("td[tdtype='header']");

                    content.push(
                        <div className="mt-20" key={`table-${numTables}`}>
                            {header ? (
                                <span id={`tableTitle${numTables}`} className="sectionTitle">
                                {header.innerHTML}
                            </span>
                            ) : (<span id={`tableTitle${numTables}`} className="sectionTitle"/>)}
                            <div className="ddFilter pad-0 pt-10">
                                <div className="row mar-0">
                                    <div className="col-md-12 pad-0">
                                        <table
                                            id={`table${numTables}`}
                                            className="priceTable"
                                            style={{width: "100%"}}
                                            dangerouslySetInnerHTML={{__html: table.innerHTML}}
                                        ></table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                    numTables++;
                });
            }

            // Extract bullet points
            const bullets = currentSub.querySelectorAll("notes bullet");
            if (bullets && bullets.length > 0) {
                const informationSectionTitle = document.querySelector("#infoSectionLabel")?.textContent || "Περισσότερες Πληροφορίες";

                content.push(
                    <div className="mt-20" id={`bullets${numBullet}`} key={`bullets-${numBullet}`}>
                        <span className="sectionTitle">{informationSectionTitle}</span>
                        <div className="ddFilter">
                            {Array.from(bullets).map((bullet, index) => {
                                const bulletType = bullet.getAttribute("bullettype");
                                return (
                                    <div className="row mar-0 mt-20" key={`bullet-${numBullet}-${index}`}>
                                        <div className="col-md-12 furtherInfoBox bull">
                                            {bulletType === "1" && <span className="bullet-icon">•</span>}
                                            <span
                                                id={`bulletText${numBullet}${index}`}
                                                className="bullet-text"
                                                dangerouslySetInnerHTML={{ __html: bullet.innerHTML }}
                                                data-bullettype={bulletType === "1" ? "1" : "0"}
                                            ></span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
                numBullet++;

            }
        });
        return content;
    };

    return (
        <div id="pricelist-revision" ref={containerRef}>
            <div>
                {displayedHtml?.map((html, index) => (
                    <div
                        key={index}
                        className="generated-content"
                        dangerouslySetInnerHTML={{__html: html}}
                    />
                ))}
            </div>
        </div>
    );
});

export default PricelistRevision;
